webpackJsonp([153499192067480],{

/***/ 348:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(21);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _reactJss = __webpack_require__(6);
	
	var _reactJss2 = _interopRequireDefault(_reactJss);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _dots = __webpack_require__(22);
	
	var _dots2 = _interopRequireDefault(_dots);
	
	var _components = __webpack_require__(17);
	
	var _containers = __webpack_require__(23);
	
	var _talks = __webpack_require__(196);
	
	var _talks2 = _interopRequireDefault(_talks);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = function styles(theme) {
	  return {
	    root: {
	      display: 'flex',
	      minHeight: '100vh',
	      flexDirection: 'column'
	    },
	
	    // MAIN
	    main: {
	      flex: '1'
	    },
	    mainContainer: {
	      padding: [20, 0],
	      '& .row': {
	        margin: 0
	      },
	      '& .col-xs-12': {
	        padding: 0
	      }
	    },
	    mainHeading: {
	      display: 'flex',
	      marginBottom: 20
	    },
	    talksHeading: {
	      margin: 'auto'
	    },
	    headingTitleClassName: {},
	    talk: {
	      marginBottom: 20
	    },
	
	    // FOOTER
	    footer: {
	      backgroundColor: theme.palette.inverted.base,
	      backgroundImage: 'url(' + _dots2.default + ')'
	    },
	    footerDrops: {
	      display: 'none'
	    },
	
	    // small -
	    '@media screen and (max-width: 30em)': {
	      // HEADING
	      headingTitleClassName: {
	        height: 80,
	        fontSize: 80
	      }
	    },
	
	    // small +
	    '@media screen and (min-width: 48em)': {
	      // MAIN
	      mainContainer: {
	        padding: [40, 20],
	        '& .row': {
	          margin: [0, '-0.5rem']
	        },
	        '& .col-xs-12': {
	          padding: [0, '0.5rem']
	        }
	      },
	      mainHeading: {
	        textAlign: 'left',
	        marginBottom: 50
	      },
	
	      // FOOTER
	      footerDrops: {
	        display: 'block'
	      }
	    }
	  };
	};
	
	var TalksPage = function TalksPage(_ref) {
	  var classes = _ref.classes;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement(
	        'title',
	        null,
	        'Talks | Real World React'
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: classes.root },
	      _react2.default.createElement(_components.Header, null),
	      _react2.default.createElement(
	        'div',
	        { className: classes.main },
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)(classes.mainContainer, 'container') },
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: (0, _classnames2.default)(classes.mainHeading, 'col-xs-12') },
	              _react2.default.createElement(_components.Heading, {
	                className: classes.talksHeading,
	                titleClassName: classes.headingTitleClassName,
	                title: 'T A L K S',
	                subtitle: 'Lessons from Leaders in the Field'
	              })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-xs-12' },
	              _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _talks2.default.map(function (talk, index) {
	                  return _react2.default.createElement(
	                    'div',
	                    {
	                      key: index,
	                      className: (0, _classnames2.default)(classes.talk, 'col-xs-12', 'col-sm-6')
	                    },
	                    _react2.default.createElement(_components.Talk, { talk: talk })
	                  );
	                })
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: classes.footer },
	        _react2.default.createElement(
	          'div',
	          { className: classes.footerDrops },
	          _react2.default.createElement(_components.Drops, { bottom: true })
	        ),
	        _react2.default.createElement(_components.Footer, { footerContent: _react2.default.createElement(_containers.SignUp, null), headerContent: _react2.default.createElement(_containers.Contact, null) })
	      )
	    )
	  );
	};
	
	exports.default = (0, _reactJss2.default)(styles)(TalksPage);
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-talks-index-js-83635f159bcbf45c401f.js